import { useEffect, useState } from "react";
import { Button, message, Modal, Select, Space, Typography } from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import { api } from "../../services/apiClient";

const { Text } = Typography;

function saveBlob(blob, fileName) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export default function WorkerDownloadControl() {
  const [workerAgents, setWorkerAgents] = useState([]);
  const [selectedWorkerId, setSelectedWorkerId] = useState(null);
  const [selectedWorkerPlatform, setSelectedWorkerPlatform] = useState("windows");
  const [downloadingWorkerType, setDownloadingWorkerType] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let mounted = true;
    api.get("/api/worker-agents/mine")
      .then((agents) => {
        if (!mounted) return;
        const availableAgents = (agents || []).filter((agent) => agent.status !== "REVOKED");
        setWorkerAgents(availableAgents);
        setSelectedWorkerId((current) => current || availableAgents[0]?.id || null);
      })
      .catch(() => {
        if (!mounted) return;
        setWorkerAgents([]);
        setSelectedWorkerId(null);
      });
    return () => {
      mounted = false;
    };
  }, []);

  const download = async (type = "package") => {
    if (!selectedWorkerId) {
      message.warning("Chọn worker cần tải");
      return;
    }
    try {
      setDownloadingWorkerType(type);
      const url = type === "engine"
        ? `/api/worker-agents/mine/${selectedWorkerId}/engine`
        : `/api/worker-agents/mine/${selectedWorkerId}/package?platform=${encodeURIComponent(selectedWorkerPlatform)}`;
      const result = await api.download(url);
      saveBlob(result.blob, result.fileName);
      setOpen(false);
      message.success(type === "engine" ? "Đã tải engine Worker Agent" : "Đã tải gói Worker Agent");
    } catch (error) {
      message.error(error.message);
    } finally {
      setDownloadingWorkerType(null);
    }
  };

  if (!workerAgents.length) return null;

  return (
    <>
      <div className="sidenav-worker-download">
        <Button
          className="sidenav-worker-download-button"
          icon={<CloudDownloadOutlined />}
          loading={Boolean(downloadingWorkerType)}
          onClick={() => setOpen(true)}
        >
          Download Worker Agent
        </Button>
      </div>
      <Modal
        title="Download Worker Agent"
        visible={open}
        onCancel={() => {
          if (!downloadingWorkerType) setOpen(false);
        }}
        closable={!downloadingWorkerType}
        maskClosable={!downloadingWorkerType}
        footer={(
          <Space>
            <Button disabled={Boolean(downloadingWorkerType)} onClick={() => setOpen(false)}>Đóng</Button>
            <Button disabled={Boolean(downloadingWorkerType)} loading={downloadingWorkerType === "engine"} onClick={() => download("engine")}>
              Download engine
            </Button>
            <Button disabled={Boolean(downloadingWorkerType)} type="primary" loading={downloadingWorkerType === "package"} onClick={() => download("package")}>
              Download full
            </Button>
          </Space>
        )}
      >
        <Space direction="vertical" size={12} style={{ width: "100%" }}>
          <Select
            disabled={Boolean(downloadingWorkerType)}
            onChange={setSelectedWorkerId}
            options={workerAgents.map((agent) => ({
              value: agent.id,
              label: `${agent.workerName || "Worker"} (${agent.status || "PENDING"})`,
            }))}
            placeholder="Chọn worker"
            style={{ width: "100%" }}
            value={selectedWorkerId}
          />
          <Select
            disabled={Boolean(downloadingWorkerType)}
            onChange={setSelectedWorkerPlatform}
            options={[
              { value: "windows", label: "Windows" },
              { value: "linux", label: "Ubuntu / Linux (x64)" },
              { value: "macos-arm64", label: "macOS (Apple Silicon)" },
              { value: "macos-x64", label: "macOS (Intel)" },
              { value: "all", label: "Full all OS" },
            ]}
            placeholder="Chọn hệ điều hành"
            style={{ width: "100%" }}
            value={selectedWorkerPlatform}
          />
          <Text>
            Download full để cài mới đầy đủ. Download engine chỉ tải file <b>application.jar</b>, dùng để ghi đè vào thư mục worker hiện tại.
          </Text>
        </Space>
      </Modal>
    </>
  );
}
